class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      if (this.input.form) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  getQuery() {
    return this.input.value.trim();
  }

  getNormalizedQuery(query) {
    if (/^(SM-|CT-)/i.test(query)) {
      return query.toUpperCase();
    }

    return query;
  }

  submitWithNormalizedQuery(normalizedQuery, event) {
    if (!this.input.form) return;

    let formData;

    try {
      formData =
        event?.submitter && typeof FormData === 'function'
          ? new FormData(this.input.form, event.submitter)
          : new FormData(this.input.form);
    } catch (error) {
      formData = new FormData(this.input.form);
    }

    const queryParamName = this.input.name || 'q';
    const action = this.input.form.getAttribute('action') || window.location.pathname;
    const redirectUrl = new URL(action, window.location.origin);
    const params = new URLSearchParams(formData);

    params.set(queryParamName, normalizedQuery);
    redirectUrl.search = params.toString();

    window.location.assign(redirectUrl.toString());
  }

  onFormSubmit(event) {
    const query = this.getQuery();

    if (!query.length) return;

    const normalizedQuery = this.getNormalizedQuery(query);

    if (normalizedQuery === query) return;

    event.preventDefault();
    this.submitWithNormalizedQuery(normalizedQuery, event);
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
